var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { DI } from '@aurelia/kernel';
import { IAuthOptions } from './configuration';
export const IStorage = DI.createInterface("IStorage", x => x.singleton(Storage));
let Storage = class Storage {
    constructor(config) {
        this.config = config;
        this.storage = this._getStorage(this.config.storage);
    }
    get(key) {
        return this.storage.getItem(key);
    }
    set(key, value) {
        return this.storage.setItem(key, value);
    }
    remove(key) {
        return this.storage.removeItem(key);
    }
    _getStorage(type) {
        if (type === 'localStorage') {
            if ('localStorage' in window && window.localStorage !== null)
                return localStorage;
            throw new Error('Local Storage is disabled or unavailable.');
        }
        else if (type === 'sessionStorage') {
            if ('sessionStorage' in window && window.sessionStorage !== null)
                return sessionStorage;
            throw new Error('Session Storage is disabled or unavailable.');
        }
        throw new Error('Invalid storage type specified: ' + type);
    }
};
Storage = __decorate([
    __param(0, IAuthOptions),
    __metadata("design:paramtypes", [Object])
], Storage);
export { Storage };
//# sourceMappingURL=storage.js.map